import { gql } from 'graphql-request'

export namespace StatusQueries {
  export namespace GET_STATUSES {
    export type Response = { potentialBookingStatuses: Status[] | null }
  }
  export function getStatuses() {
    return gql`
      query getStatuses($filter: PotentialBookingStatusFilter = { active: true }) {
        potentialBookingStatuses(filter: $filter) {
          id
          description
          lifecycleState
          manualChangeAllowed
        }
      }
    `
  }
}

export interface Status {
  description: string
  id: number
  lifecycleState?: string
  manualChangeAllowed?: boolean
}
